//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminCompanyController_findAll,
  Response$AdminCompanyController_findAll$Status$200,
  ResponseContentType$AdminCompanyController_findAll,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminCompanyController_findAll = (options: {
  params: Params$AdminCompanyController_findAll['parameter'];
  config?: QueryOptions<
    Response$AdminCompanyController_findAll$Status$200[ResponseContentType$AdminCompanyController_findAll]
  >;
}) =>
  useApiClient<
    Params$AdminCompanyController_findAll,
    Response$AdminCompanyController_findAll$Status$200[ResponseContentType$AdminCompanyController_findAll]
  >({
    method: 'AdminCompanyController_findAll',
    params: { parameter: options.params },
    config: options.config,
  });
